import { Attachment } from './../../shared-components/models/attachment.model';

export class ProfileAttachment extends Attachment {
    FileID = -1;
    TableID = 18;
    DocOwnerID: number;
    FolderID = -1;
    MyFileName = '';
    OriginalFileName = '';
    AllowParentToView = true;
    DateAttached = new Date();
    FormDocType_ID = -1;
}